import React from 'react';

const FirebaseContext = React.createContext({});

export const FirebaseProvider = FirebaseContext.Provider;

export default FirebaseContext;
